import {
  App,
  BaseTransientState,
  FeatureToggles,
  Regexps,
  Rolle,
  VermietetesModalObjekt,
  VorvertragVorschaedenState,
} from '@ps20-frontend/frontend-models';
import { AnyAction } from 'redux';
import {
  GlobalActions,
  RoleDeterminedPayload,
  StreckenTarifierungRequestEvents,
} from '@ps20-frontend/shop-integration-redux';
import { vorvertragVorschaedenErmitteltReducer } from '@ps20-frontend/reducers';
import { Zahlungsart } from '@ps20/bff-models';
import { RsActions } from '../rsActions';
import { IAppState } from '../appState';
import { vermieterModalReducer } from './vermieterModal.reducer';

export interface TransientState extends BaseTransientState, VorvertragVorschaedenState, Rolle {
  zahlungsartAlt: Zahlungsart;
  rbdAlt: number;
  tbAlt: number;
  beginnDatumAlt: string;
  ablaufDatumAlt: string;
  productLoadingIsInProgress: boolean;
  vermieterModalVermieteteObjekte: Array<VermietetesModalObjekt>;
}

export const transientStateReducer = function (
  sectionState: TransientState = null,
  action: AnyAction,
  appState: IAppState,
): TransientState {
  const newState = {
    ...sectionState,
    vermieterModalVermieteteObjekte: vermieterModalReducer(
      sectionState?.vermieterModalVermieteteObjekte || [],
      action,
      appState,
    ),
  };
  switch (action.type) {
    case RsActions.ZURUECK_ZUM_SHOP_MODAL_OPEN: {
      return { ...newState, zurueckZumShopModalOpen: true };
    }
    case RsActions.ZURUECK_ZUM_SHOP_MODAL_CLOSE: {
      return { ...newState, zurueckZumShopModalOpen: false };
    }
    case GlobalActions.TARIFIERUNG_HAS_STARTED: {
      return { ...newState, tarifierungIsInProgress: true };
    }
    case GlobalActions.TARIFIERUNG_HAS_ENDED: {
      return { ...newState, tarifierungIsInProgress: false };
    }
    case RsActions.PRODUCT_LOADING_IN_PROGRESS: {
      return { ...newState, productLoadingIsInProgress: action.payload };
    }
    case StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_RS: {
      const payload = action.payload;
      if (payload.response?.data?.taasStatus) {
        return {
          ...sectionState,
          fehlerCodeTaas: payload.response.data.taasStatus.fehlerCode,
        };
      }
      return { ...sectionState, fehlerCodeTaas: null };
    }
    case GlobalActions.SET_PRICE_GUARANTEE: {
      return { ...sectionState, priceGuarantee: action.payload };
    }
    case GlobalActions.CHANGE_RELEVANT_RISKDATA_HASH: {
      return {
        ...sectionState,
        priceGuarantee: false,
      };
    }
    case GlobalActions.ROLE_DETERMINED: {
      const actionPayload: RoleDeterminedPayload = action.payload;
      return { ...sectionState, role: actionPayload.role };
    }
    case GlobalActions.VORVERTRAG_VORSCHAEDEN_ERMITTELT: {
      return vorvertragVorschaedenErmitteltReducer(sectionState, action, {
        appId: App.RS,
      });
    }
    case GlobalActions.FEATURE_TOGGLE_RECEIVED: {
      const actionPayload: FeatureToggles = action.payload;
      return { ...sectionState, featureToggles: actionPayload };
    }
    case GlobalActions.REGEXPS_RECEIVED: {
      const actionPayload: Regexps = action.payload;
      return { ...sectionState, regexps: actionPayload };
    }
    case GlobalActions.SETTINGS_RECEIVED:
      return {
        ...sectionState,
        settings: action.payload,
      };
    case GlobalActions.KOOPERATIONEN_LIST_RECEIVED: {
      return {
        ...sectionState,
        kooperationen: action.payload,
      };
    }
    default:
      return newState;
  }
};
